var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoType(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "27px",
    height: "26px",
    viewBox: "0 0 27 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "C8D3BAB3-5EB8-4D3F-ABCB-ED8D226B1D02") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-284.000000, -608.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tpye",
    transform: "translate(284.000000, 608.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    fillRule: "nonzero",
    x: 9,
    y: 1,
    width: 17,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    fillRule: "nonzero",
    x: 1,
    y: 9,
    width: 8,
    height: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.462,10.482 C22.462,12.19 21.356,13.156 19.228,13.8 L19.186,14.29 L17.66,14.626 L17.478,12.4 L18.038,12.246 C19.606,11.812 20.124,11.378 20.124,10.678 C20.124,10.062 19.606,9.698 18.752,9.698 C17.73,9.698 16.694,10.146 15.798,10.748 L15.49,8.69 C16.4,8.102 17.534,7.668 19.046,7.668 C21.188,7.668 22.462,8.704 22.462,10.482 Z M19.564,18 L17.184,18 L17.184,15.48 L19.564,15.48 L19.564,18 Z",
    id: "?",
    fill: "#FFFFFF"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoType);
export default __webpack_public_path__ + "static/media/ico_type.b57e6cb1e725de0463ed451acd109a4b.svg";
export { ForwardRef as ReactComponent };